import config from "../../config/config";
import { getToken } from "../../lib";

function headers() {
  return {
    "Authenticity-Token": getToken(),
    "Accept": "application/json",
    "Content-Type": "application/json",
  }
}

export const updateAddress = (data) => {
  return fetch(`${config.URI}/api/v1/address_book/${data.id}`, {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify(data)
  }).then((r) => r.json());
};

export const addAddress = (data) => {
  return fetch(`${config.URI}/api/v1/address_book`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify(data)
  }).then((r) => r.json());
};

export const destroyAddress = (id) => {
  return fetch(`${config.URI}/api/v1/address_book/${id}`, {
    method: "DELETE",
    headers: {
      "Authenticity-Token": getToken(),
      Accept: "application/json",
    },
  }).then((r) => r.json());
};

export const addGroup = (data) => {
  return fetch(`${config.URI}/api/v1/group`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify(data)
  }).then(r => r.json())
}

export const updateGroup = (data) => {
  return fetch(`${config.URI}/api/v1/group/${data.id}`, {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify(data)
  }).then(r => r.json())
}
export const deleteGroup = (id) => {
  return fetch(`${config.URI}/api/v1/group/${id}`, {
    method: "DELETE",
    headers: {
      'Authenticity-Token': getToken(),
      'Accept': 'application/json',
    },
  }).then(r => r.json())
}


// WEBPACK FOOTER //
// src/components/EmailAddressBook/actions.js